<h4 class="head mt-3 ml-2 ml-xl-0">
    {{ 'web.awards' | translate }}
</h4>

<div class="row px-3 px-lg-0 mb-3 mt-3">
    <div class="col-12 col-sm-6">
        <select class="form-control" [(ngModel)]="selectedYear">
            @for (y of years; track $index) {
                <option [ngValue]="y">{{ y }}</option>
            }
        </select>
    </div>
</div>

<div class="d-flex table-scrollable">
    <div class="table-scrollable__data flex-grow-1">
        <table class="table-scrollable__data__table" data-cy="app-table-left-data">
            <thead>
            <tr>
                <th class="table-scrollable__table-th">
                    {{ 'web.award' | translate }}
                </th>
                <th class="table-scrollable__table-th">
                    {{ 'web.season' | translate }}
                </th>
                <th class="table-scrollable__table-th" colspan="2">
                    {{ 'web.player' | translate }}
                </th>
                <th class="table-scrollable__table-th" colspan="2">
                    {{ 'web.participant' | translate }}
                </th>
            </tr>
            </thead>
            <tbody>
                @for (a of filteredAwards; track $index) {
                    <tr class="table-scrollable__table-row">
                        <td class="table-scrollable__table-td">{{ a.award.name }}</td>
                        <td class="table-scrollable__table-td">{{ a.season.year }}</td>
                        <td class="table-scrollable__table-td text-center" style="width: 55px">
                            @if (a.player) {
                                <div class="img-circle img-circle--40 mr-3 rounded-circle">
                                    <img
                                        (error)="imageError($event, 'avatar')"
                                        [attr.alt]="a.player?.name"
                                        [src]="'/assets/players/photos/' + a.player?.id + '.png'"
                                        height="40"
                                        loading="lazy"
                                    />
                                </div>
                            }
                        </td>
                        <td class="table-scrollable__table-td">
                            @if (a.player) {
                                <a
                                    [routerLink]="['/page/sport/player', sportName + '-' + sportId, a.player.id]"
                                    class="text-reset table-scrollable-team"
                                >
                                    {{ a.player.name }}
                                </a>
                            }
                        </td>
                        <td class="table-scrollable__table-td text-center" style="width: 55px">
                            @if (a.participant?.image) {
                                <img src="{{ a.participant.image }}" alt="{{ a.participant.name }}" height="40" />
                            }
                        </td>
                        <td class="table-scrollable__table-td">
                            @if (a.participant) {
                                <a
                                    [routerLink]="['/page/sport/participant', sportName + '-' + sportId, a.participant.id]"
                                    class="text-reset table-scrollable-team"
                                >
                                    {{ a.participant.name }}
                                </a>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
